<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!--基准月份-->
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC002132')">
						<el-date-picker
							v-model="searchParams.searchDate"
							@change="changeSearchDate"
							type="month"
							align="right"
							format="yyyy-MM"
							value-format="yyyyMM"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
				<!-- 部品类型 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000059')"
						paramKey="partType"
						:options="partTypeList"
						:propData="searchParams.partType"
						:showAll="false"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				
			</el-row>

			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/MdjMGraph/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	components: {
		SelectCombo
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		searchList() {
			//this.setPagingInfo_({ key: 'currentPage', value: 1 });
			//this.$emit('resetPage');
			if(this.searchParams.partType != this.searchParams.prePartType){
				this.$emit('refreshCols');
			}
			if (this.searchParams.searchDate === null) {
				let today = this.$moment().format('YYYYMM');
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001682')
				}); 
				this.setSearchParam_({ key: 'searchDate', value: today });
			} else {
				this.$sf_toggleLoading(true);
				this.setState_({ key: 'isLoading', value: false });
				this.getMdjMStastic_()
				.then(header => {
					this.setSearchParam_({ key: 'prePartType', value: this.searchParams.partType });
					this.$emit('doLayoutTb');
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
				
			}
		},
		changeSearchDate(data) {
			let today = this.$moment().format('YYYYMM');
			if (data === null || data === '') {
				let thisMonth = today.substring(0, 7);
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000008'),
					message: this.getMessage_('QWCC001622')
				}); 
				this.setSearchParam_({ key: 'searchDate', value: thisMonth });
			} else {
				this.setSearchParam_({ key: 'searchDate', value: data });
				this.searchList();
			}
		},
		onCheck(key, value) {
			if (value) this.setSearchParam_({ key, value: 'Y' });
			else this.setSearchParam_({ key, value: 'N' });
		}
	}
};
</script>

<style></style>
